// src/admin/components/AddInventoryItemForm.js

import React, { useState } from 'react';
import { API_BASE_URL } from '../config';

/**
 * Form per creare un nuovo prodotto di inventario all'interno di un ristorante.
 * 
 * Props:
 *  - restaurantId (number): l'ID del ristorante selezionato
 *  - onSuccess (function): callback da chiamare dopo la creazione
 */
export default function AddInventoryItemForm({ restaurantId, onSuccess }) {
  const [name, setName] = useState('');
  const [quantity, setQuantity] = useState('');
  const [unit, setUnit] = useState('kg');
  const [costPerUnit, setCostPerUnit] = useState('');

  const token = localStorage.getItem('access_token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Verifica che il ristorante sia selezionato
    if (!restaurantId) {
      alert('Seleziona prima un ristorante.');
      return;
    }
    // Verifica che i campi necessari siano compilati
    if (!name || !quantity || !costPerUnit) {
      alert('Compila nome, quantità e costo.');
      return;
    }

    const payload = {
      restaurant_id: restaurantId,
      name,
      unit,
      quantity: parseFloat(quantity),
      cost_per_unit: parseFloat(costPerUnit),
    };

    try {
      const url = `${process.env.REACT_APP_API_URL}/inventory_items`;
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errorData = await res.json();
        const msg = errorData.detail || 'Errore durante la creazione del prodotto';
        alert(msg);
        return;
      }

      alert('Prodotto creato con successo!');
      // Reset campi input
      setName('');
      setQuantity('');
      setCostPerUnit('');

      // Se abbiamo una callback di successo, chiamiamola
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error('AddInventoryItemForm - errore:', error);
      alert('Errore di rete o server.');
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.subtitle}>Aggiungi nuovo prodotto</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.field}>
          <label style={styles.label}>Nome prodotto</label>
          <input
            type="text"
            placeholder="Es. Farina"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Quantità iniziale</label>
          <input
            type="number"
            step="0.01"
            placeholder="Es. 10"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Unità di misura</label>
          <select
            value={unit}
            onChange={(e) => setUnit(e.target.value)}
            style={styles.select}
          >
            <option value="kg">kg</option>
            <option value="l">litri</option>
            <option value="pz">pezzi</option>
          </select>
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Prezzo per unità</label>
          <input
            type="number"
            step="0.01"
            placeholder="Es. 2.50"
            value={costPerUnit}
            onChange={(e) => setCostPerUnit(e.target.value)}
            style={styles.input}
          />
        </div>

        <button type="submit" style={styles.button}>
          Crea Prodotto
        </button>
      </form>
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: '#FAFAFA',
    borderRadius: '6px',
    padding: '20px',
    marginBottom: '20px',
    border: '1px solid #EEE',
  },
  subtitle: {
    margin: '0 0 10px 0',
    color: '#333333',
    fontSize: '1.2rem',
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1.5rem',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '220px',
  },
  label: {
    marginBottom: '6px',
    fontWeight: '600',
    color: '#333333',
  },
  input: {
    padding: '8px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '0.9rem',
  },
  select: {
    padding: '8px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '0.9rem',
    backgroundColor: '#fff',
  },
  button: {
    padding: '10px 16px',
    backgroundColor: '#FF8C00', // Primary
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '1rem',
    marginTop: '1.5rem',
  },
};
